import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		display: "flex",
		height: `calc(var(--navigation-height) - ${tokens.strokeWidthThin})`,
		...shorthands.borderBottom(
			tokens.strokeWidthThin,
			"solid",
			tokens.colorNeutralStroke1
		),
	},
	rightContainer: {
		display: "flex",
		alignItems: "center",
		...shorthands.margin(0, 0, 0, "auto"),
		...shorthands.gap(tokens.spacingHorizontalL),
		...shorthands.padding(0, tokens.spacingHorizontalS),
	},
	accountPopover: {
		minWidth: "16rem",
		maxWidth: "25rem",
		maxHeight: "80%",
		...shorthands.padding(0),
	},
	newInteractionButton: {
		height: "32px",
	},
	isNotJoinedBorder: {
		border: `2px solid ${tokens.colorPaletteRedBackground3}`,
	},
});
